export const fetchPresentationAccessKey = accessKey => ({
  type: "FETCH_PRESENTATION_ACCESS_KEY",
  payload: accessKey
});

export const setAccessKeyDuration = duration => ({
  type: "SET_ACCESS_KEY_DURATION",
  duration
});

export const generatePresentationAccessKey = resp => {
  return {
    type: "GENERATE_PRESENTATION_ACCESS_KEY",
    payload: resp
  };
};

export const verifyPresentationAccessKey = accessKey => ({
  type: "VERIFY_PRESENTATION_ACCESS_KEY",
  payload: accessKey
});

export const initAccessKey = () => {
  return {
    type: "INIT_ACCESS_KEY"
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/access-key.js